<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { TypeIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .insertBelow(({ escapeList: true, onlyIfEmpty: true }))
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="TypeIcon"
    @click="run"
    @keydown.enter="run"
  >
    Text
  </SuggestionListItem>
</template>
